export default "__VITE_ASSET__BXcjXiKi__"